import { __extends } from "tslib";
import { PerspectiveProjection, Transform } from '@awayjs/core';
import { ImageCube } from '@awayjs/stage';
import { View } from '@awayjs/view';
import { RenderGroup, DistanceRenderer } from '@awayjs/renderer';
import { ShadowTextureCube } from '../textures/ShadowTextureCube';
import { ShadowMapperBase, _Shader_ShadowMapperBase } from './ShadowMapperBase';
var PointShadowMapper = /** @class */ (function (_super) {
    __extends(PointShadowMapper, _super);
    function PointShadowMapper(imageCube) {
        if (imageCube === void 0) { imageCube = null; }
        var _this = _super.call(this) || this;
        _this._needsRender = new Array();
        _this._size = 512;
        _this._imageCube = imageCube || new ImageCube(_this._size);
        _this._textureMap = new ShadowTextureCube(_this, _this._imageCube);
        _this.iAddTexture(_this._textureMap);
        _this.initCameras();
        return _this;
    }
    Object.defineProperty(PointShadowMapper.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return PointShadowMapper.assetType;
        },
        enumerable: true,
        configurable: true
    });
    PointShadowMapper.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._textureMap.image = null;
        this._textureMap = null;
        this._imageCube = null;
    };
    PointShadowMapper.prototype.initCameras = function () {
        this._depthProjections = new Array();
        // posX, negX, posY, negY, posZ, negZ
        this.addProjection(0, 90, 0);
        this.addProjection(0, -90, 0);
        this.addProjection(-90, 0, 0);
        this.addProjection(90, 0, 0);
        this.addProjection(0, 0, 0);
        this.addProjection(0, 180, 0);
    };
    PointShadowMapper.prototype.addProjection = function (rotationX, rotationY, rotationZ) {
        var projection = new PerspectiveProjection();
        projection.transform = new Transform();
        projection.transform.rotateTo(rotationX, rotationY, rotationZ);
        projection.near = .01;
        projection.fieldOfView = 90;
        this._depthProjections.push(projection);
    };
    PointShadowMapper.prototype._updateSize = function () {
        this._imageCube._setSize(this._size);
    };
    /**
     *
     * @param projection
     * @private
     */
    PointShadowMapper.prototype._updateProjection = function (projection) {
        var light = (this._light);
        var maxDistance = light.fallOff;
        var pos = this._light.transform.matrix3D.position;
        // todo: faces outside frustum which are pointing away from camera need not be rendered!
        for (var i = 0; i < 6; ++i) {
            this._depthProjections[i].far = maxDistance;
            this._depthProjections[i].transform.moveTo(pos.x, pos.y, pos.z);
            this._needsRender[i] = true;
        }
    };
    /**
     *
     * @param view
     * @param target
     * @param renderer
     * @private
     */
    PointShadowMapper.prototype._renderMap = function (partition, renderGroup) {
        var distanceRenderer = RenderGroup
            .getInstance(new View(null, renderGroup.stage), DistanceRenderer)
            .getRenderer(partition);
        for (var i = 0; i < 6; ++i) {
            if (this._needsRender[i]) {
                distanceRenderer.view.target = this._imageCube;
                distanceRenderer.view.projection = this._depthProjections[i];
                distanceRenderer.render(null, i);
            }
        }
    };
    PointShadowMapper.assetType = '[asset PointShadowMapper]';
    return PointShadowMapper;
}(ShadowMapperBase));
export { PointShadowMapper };
import { ShaderBase } from '@awayjs/renderer';
/**
 * _Shader_PointShadowMapper provides an abstract method for simple (non-wrapping) shadow map methods.
 */
var _Shader_PointShadowMapper = /** @class */ (function (_super) {
    __extends(_Shader_PointShadowMapper, _super);
    function _Shader_PointShadowMapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    _Shader_PointShadowMapper.prototype._initVO = function (chunkVO) {
        _super.prototype._initVO.call(this, chunkVO);
        chunkVO.needsGlobalFragmentPos = true;
    };
    /**
     * @inheritDoc
     */
    _Shader_PointShadowMapper.prototype._getVertexCode = function (regCache, sharedRegisters) {
        this._depthMapCoordReg = sharedRegisters.globalPositionVarying;
        return '';
    };
    return _Shader_PointShadowMapper;
}(_Shader_ShadowMapperBase));
export { _Shader_PointShadowMapper };
ShaderBase.registerAbstraction(_Shader_PointShadowMapper, PointShadowMapper);
